import type React from 'react';
import { useEffect } from 'react';

const useFocusElementToolbarInput = (
  inputRef: React.RefObject<HTMLInputElement>
) => {
  useEffect(() => {
    if (inputRef.current) {
      const input = inputRef.current;

      // Some operations might focus Slate, which would steal the focus away from the input.
      // Let's re-focus the input after a render.
      window.requestAnimationFrame(() => {
        input.focus();
        input.select();
      });
    }
  }, []);
};

export default useFocusElementToolbarInput;
